import React, { ReactElement } from 'react';
import { Dialog, Paragraph, ButtonPattern, Button } from '@constellation/core';
import { useNavigate } from '@interstellar/react-app-routing';
import { ACCESS_TOKEN, GLOBAL_IDS } from '../../utils/constant';

interface IdvPreviousDialogProps {
  dialogTitle?: string;
  dialogContent?: string;
  isDialogOpen?: boolean;
  setIsDialogOpen?: any;
  noBtnLabel?: string;
  yesBtnLabel?: string;
  yesBtnLink?: string;
}

function IdvPreviousDialog({
  dialogTitle,
  dialogContent,
  isDialogOpen,
  setIsDialogOpen,
  noBtnLabel,
  yesBtnLabel,
  yesBtnLink,
}: IdvPreviousDialogProps): ReactElement {
  const navigate = useNavigate();

  const handleYesBtn = () => {
    setIsDialogOpen(false);
    sessionStorage.removeItem(ACCESS_TOKEN);
    sessionStorage.removeItem(GLOBAL_IDS);
    sessionStorage.setItem(GLOBAL_IDS, JSON.stringify({ idvRetryCount: 0 }));
    navigate(yesBtnLink);
  };

  return (
    <Dialog
      onClose={() => setIsDialogOpen(false)}
      open={isDialogOpen}
      title={dialogTitle}
    >
      <Paragraph>{dialogContent}</Paragraph>
      <ButtonPattern marginBottom="none">
        <Button onClick={handleYesBtn} variation="primary">
          {yesBtnLabel}
        </Button>
        <span>
          <Button onClick={() => setIsDialogOpen(false)} variation="secondary">
            {noBtnLabel}
          </Button>
        </span>
      </ButtonPattern>
    </Dialog>
  );
}

export default IdvPreviousDialog;
